import { DatePicker, Table, Input, Tag, Button, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useState } from 'react';
import styles from '../styles/DriverLogs.module.css';
import Header from '../../../components/HeaderList';
import { ReactComponent as Calendar } from '../../../assets/icons/calendar.svg';
import { ReactComponent as Detail } from '../../../assets/icons/eye-box.svg';
import moment from 'moment';
import LogDetailsModal from './LogDetailsModal';

export const DRIVER_LOG_ACTIONS = [
    { value: 'ACTION_BAR_MOUNTED', label: 'App Abierta / Barra Cargada' },
    { value: 'ORDER_ACCEPTED_SUCCESS', label: 'Orden Aceptada con Éxito' },
    { value: 'ORDER_REJECTED_SUCCESS', label: 'Orden Rechazada con Éxito' },
    { value: 'ORDER_TIMEOUT', label: 'Tiempo Agotado de Orden' },
    { value: 'PUSHER_EVENT_RECEIVED', label: 'Evento de Pusher Recibido' },
    { value: 'PUSHER_CONNECTED', label: 'Pusher Conectado' },
    { value: 'PUSHER_CONNECTING', label: 'Pusher Conectando' },
    { value: 'PUSHER_DISCONNECTING', label: 'Pusher Desconectando' },
    { value: 'PUSHER_DISCONNECTED', label: 'Pusher Desconectado' },
    { value: 'PUSHER_ERROR', label: 'Error de Pusher' },
    { value: 'NotificarDriver', label: 'Notificar Motorista' },
    { value: 'FIREBASE_SEND_FAILED', label: 'Fallo al enviar notificación Firebase' },
    { value: 'PUSHER_SEND_FAILED', label: 'Fallo al enviar notificación Pusher' }
];

const ReportUI = ({ onChangeDates, onTableChange, dates, loading, logs, total, page, limit }) => {

    const [filters, setFilters] = useState({
        driver_id: '',
        ticket: '',
        action: ''
    });

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedLog, setSelectedLog] = useState(null);

    const openDetails = (record) => {
        let detailsObj = {};
        try {
            detailsObj = typeof record.details === 'string' ? JSON.parse(record.details) : record.details;
        } catch (e) {
            detailsObj = { 'Raw Data': record.details };
        }

        setSelectedLog({ ...record, parsedDetails: detailsObj });
        setIsModalVisible(true);
    };

    const columns = [
        { title: '#', dataIndex: 'id', align: 'center' },
        { 
            title: 'Motorista ID', 
            key: 'driver_id',
            dataIndex: ['driver_id', 'id'], 
            align: 'center',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        placeholder="Buscar ID"
                        value={selectedKeys[0]}
                        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value.replace(/\D/g, '')] : [])}
                        onPressEnter={() => confirm()}
                        style={{ width: 150, marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button type="primary" onClick={() => confirm()} icon={<SearchOutlined />} size="small" style={{ width: 70 }}>
                            Ok
                        </Button>
                        <Button onClick={() => { clearFilters(); confirm(); }} size="small" style={{ width: 70 }}>
                            Limpiar
                        </Button>
                    </Space>
                </div>
            ),
            filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
            filteredValue: filters.driver_id ? [filters.driver_id] : null
        },
        { title: 'Motorista Nombre', dataIndex: ['driver_id', 'name'], align: 'center' },
        { title: 'Código Empleado', dataIndex: ['driver_id', 'employee_id'], align: 'center' },
        { 
            title: 'Ticket Orden', 
            key: 'ticket',
            dataIndex: 'ticket', 
            align: 'center',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        placeholder="Buscar Ticket"
                        value={selectedKeys[0]}
                        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => confirm()}
                        style={{ width: 150, marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button type="primary" onClick={() => confirm()} icon={<SearchOutlined />} size="small" style={{ width: 70 }}>
                            Ok
                        </Button>
                        <Button onClick={() => { clearFilters(); confirm(); }} size="small" style={{ width: 70 }}>
                            Limpiar
                        </Button>
                    </Space>
                </div>
            ),
            filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
            filteredValue: filters.ticket ? [filters.ticket] : null
        },
        { title: 'Canal', dataIndex: 'channel', align: 'center' },
        {
            title: 'Acción',
            dataIndex: 'action',
            align: 'center',
            filters: DRIVER_LOG_ACTIONS.map(action => ({ text: action.label, value: action.value })),
            filterMultiple: true,
            filteredValue: filters.action ? filters.action.split(',') : null,
            render: (action) => <Tag className={styles.orangeTag}>{action}</Tag>
        },
        { title: 'IP', dataIndex: 'ip', align: 'center' },
        { 
            title: 'Fecha', 
            dataIndex: 'register_date', 
            align: 'center', 
            render: (date) => date ? moment(date).format('DD/MM/YYYY HH:mm A') : '' 
        },
        {
            title: 'Ver detalle', dataIndex: 'id', align: 'center', render: (_, record) => (
                <Button
                    type="text"
                    onClick={() => openDetails(record)}
                    icon={<Detail className={styles.detailIcon} />}
                    className={styles.detailButton}
                />
            )
        }
    ];

    return (
        <div>
            <Header title={'DRIVER LOGS'} back={'/reportes'} />
            
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
                <DatePicker.RangePicker
                    size='large'
                    suffixIcon={<Calendar />}
                    allowClear
                    showTime={{ format: 'HH:mm:ss' }}
                    format={'DD/MM/YYYY HH:mm:ss'}
                    placeholder={['Fecha Inicio', 'Fecha Fin']}
                    value={dates}
                    onChange={onChangeDates}
                />
            </div>

            <Table
                columns={columns}
                dataSource={logs}
                loading={loading}
                rowKey="id"
                scroll={{ x: 'max-content' }}
                pagination={{
                    current: page,
                    pageSize: limit,
                    total: total,
                    showSizeChanger: false
                }}
                onChange={(pagination, tableFilters, sorter) => {
                    const newDriverId = tableFilters.driver_id ? tableFilters.driver_id[0] || '' : '';
                    const newTicket = tableFilters.ticket ? tableFilters.ticket[0] || '' : '';
                    
                    let newAction = '';
                    if (tableFilters.action && tableFilters.action.length > 0) {
                        newAction = tableFilters.action.slice(0, 3).join(',');
                    }
                    
                    let newFilters = filters;
                    if (newDriverId !== filters.driver_id || newTicket !== filters.ticket || newAction !== filters.action) {
                        newFilters = { 
                            ...filters, 
                            driver_id: newDriverId,
                            ticket: newTicket,
                            action: newAction 
                        };
                        setFilters(newFilters);
                    }
                    onTableChange(pagination, newFilters);
                }}
            />

            <LogDetailsModal
                visible={isModalVisible}
                selectedLog={selectedLog}
                onClose={() => setIsModalVisible(false)}
            />
        </div>
    );
}

export default ReportUI;
